import * as React from 'react'

import { useSelector } from 'react-redux'

import { ApplicationState } from '@store/types'
import { ProfileHeader } from '@organisms'
import { Header } from '@atoms'
import { BridgeService } from '@services/bridge'

import { Container, Content, ContainerFooter } from './styles'

interface Props {
  children: React.ReactElement | React.ReactElement[]
  stickyFooter?: React.ReactElement | React.ReactElement[]
  footerTwoButtonsSpace?: string
  stickyContainerFooterBottom?: string
  positionFooter?: string
  rightIcon?: 'house' | 'download' | 'more' | 'question-mark' | React.ReactNode
  onRightButtonClick?: () => void
  showLeftIcon?: boolean
  showRightIcon?: boolean
  titleHeader?: string
  headerPosition?: string
}

const Page = ({
  children,
  stickyFooter,
  footerTwoButtonsSpace = '200px',
  stickyContainerFooterBottom,
  positionFooter,
  rightIcon,
  onRightButtonClick,
  showLeftIcon,
  showRightIcon,
  titleHeader = 'Refinanciamento Consignado',
  headerPosition = '',
}: Props) => {
  const { isApp } = useSelector((state: ApplicationState) => state.ui.navigation)

  React.useEffect(() => {
    if (isApp && !BridgeService.isBrowser()) {
      BridgeService.editToolbar('', false, false).catch(() => {
        // Ignora erro silenciosamente quando bridge não está disponível
      })
    }
  }, [isApp])

  return (
    <>
      {isApp ? (
        <Header
          showLeftIcon={showLeftIcon}
          showRightIcon={showRightIcon}
          rightIcon={rightIcon}
          onRightButtonClick={onRightButtonClick}
          headerPosition={headerPosition}
        >
          {titleHeader}
        </Header>
      ) : (
        <></>
      )}
      <Container id="page-container">
        {!isApp && <ProfileHeader />}
        <Content isWeb={!isApp} id="page-content" footerTwoButtonsSpace={footerTwoButtonsSpace}>
          {children}
        </Content>
        {stickyFooter && (
          <ContainerFooter
            id="page-sticky-footer"
            stickyContainerFooterBottom={stickyContainerFooterBottom}
            positionFooter={positionFooter}
          >
            {stickyFooter}
          </ContainerFooter>
        )}
      </Container>
    </>
  )
}
export default Page
